import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Frontend/Footer/Footer";
import SidebarNav from "../components/Navigation/SideBarNav";
import NavTop from "../components/Navigation/NavTop";
import "./ClientLayoutV2.css";

const ClientLayoutV2 = () => {
  const location = useLocation();

  const [show_footer, showFooter] = useState(true);

  useEffect(() => {
    // Hide footer for watchboard and legacy ai_assistant pages
    const hide =
      location.pathname.startsWith("/watchboard") ||
      location.pathname.includes("ai_assistant") ||
      location.pathname.startsWith("/customers");
    showFooter(!hide);
  }, [location.pathname]);

  return (
    <>
      {/* <NavTop/> */}
      <div className="client-layout-main-layout">
        <SidebarNav />

        <div
          className="client-layout-main-layout-content"
          style={{ maxWidth: "100%", marginLeft: "75px", marginRight: "0", padding: "0" }}
        >
          <Outlet />
        </div>
      </div>

      {show_footer && <Footer />}
    </>
  );
};

export default ClientLayoutV2;
